// src/components/Column.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Droppable } from "react-beautiful-dnd";
import Skeleton from "@mui/material/Skeleton";
import TicketCard from "./TicketCard";

const Container = styled.div`
  border-radius: 2.5px;
  width: 300px;
  height: 80vh;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-right: 16px;
  background-color: #f7f7f7;
`;

const Header = styled.div`
  display: flex;
  background-color: #fff;
  height: 60px;
  align-items: center;
  border-bottom: 1px solid #ddd;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
`;

const TaskList = styled.div`
  padding: 8px;
  transition: background-color 0.2s ease;
  background-color: ${({ isDraggingOver }) =>
    isDraggingOver ? "#e3f2fd" : "#fff"};
  min-height: 100px;
  flex-grow: 1;
`;

export default function Column({
  title,
  tasks,
  id,
  borderColor,
  renderSkeleton,
  onSelectCard,
}) {
  console.log(
    `[Column] mounting droppableId="${id}", tasks.length=${tasks.length}`,
    tasks
  );
  const [count, setCount] = useState(tasks.length);

  useEffect(() => {
    setCount(tasks.length);
  }, [tasks]);

  return (
    <Container>
      <Header>
        <div
          style={{ borderLeft: `5px solid ${borderColor}`, height: "100%" }}
        />
        <TitleWrapper>
          <span style={{ fontSize: "16px", fontWeight: 600 }}>{title}</span>
          <span style={{ fontSize: "14px", color: "#666" }}># {count}</span>
        </TitleWrapper>
      </Header>
      {/* <Droppable droppableId={id}>
        {(provided, snapshot) => (
           console.log(`[Droppable "${id}"] isDraggingOver=${snapshot.isDraggingOver}`, provided); 
          return (
          <TaskList
            ref={provided.innerRef}
            {...provided.droppableProps}
            isDraggingOver={snapshot.isDraggingOver}
          >
            {renderSkeleton
              ? Array(4)
                  .fill(null)
                  .map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rectangular"
                      width="100%"
                      height={100}
                      sx={{
                        mb: 1,
                        borderRadius: 1,
                        bgcolor: "#e0e0e0",
                        animation: "pulse 0.6s ease-in-out infinite",
                      }}
                    />
                  ))
              : tasks.map((ticket, index) => (
                  <TicketCard
                    key={ticket.id}
                    ticket={ticket}
                    index={index}
                    onSelect={() => onSelectCard(ticket)}
                  />
                ))}
            {provided.placeholder}
          </TaskList>
          );
}}
      </Droppable> */}
      <Droppable droppableId={id}>
        {(provided, snapshot) => {
          // 🚩 log du snapshot et des props du droppable
          console.log(
            `[Droppable "${id}"] isDraggingOver=${snapshot.isDraggingOver}`,
            provided
          );
          return (
            <TaskList
              ref={provided.innerRef}
              {...provided.droppableProps}
              isDraggingOver={snapshot.isDraggingOver}
            >
              {renderSkeleton
                ? Array(4)
                    .fill(null)
                    .map((_, i) => (
                      <Skeleton
                        key={i}
                        variant="rectangular"
                        width="100%"
                        height={100}
                        sx={{
                          mb: 1,
                          borderRadius: 1,
                          bgcolor: "#e0e0e0",
                          animation: "pulse 0.6s ease-in-out infinite",
                        }}
                      />
                    ))
                : tasks.map((ticket, index) => (
                    <TicketCard
                      key={ticket.id}
                      ticket={ticket}
                      index={index}
                      onSelect={() => onSelectCard(ticket)}
                    />
                  ))}
              {provided.placeholder}
            </TaskList>
          );
        }}
      </Droppable>
    </Container>
  );
}
